"use client";

import classnames from "classnames";

import type { AppConfig } from "./types";
import styles from "./sidebar.module.scss";

interface SidebarLogoProps {
  app: AppConfig;
  collapsed: boolean;
  onCollapseToggle: () => void;
  updateAvailable?: boolean;
  onUpdate?: () => void;
}

export function SidebarLogo({
  app,
  collapsed,
  onCollapseToggle,
  updateAvailable,
  onUpdate,
}: SidebarLogoProps) {
  const handleIconClick = () => {
    if (collapsed) {
      onCollapseToggle();
    } else if (updateAvailable && onUpdate) {
      onUpdate();
    }
  };

  const isClickable = collapsed || (updateAvailable && onUpdate);

  return (
    <div className={styles.logoArea}>
      <div className={styles.logoRow}>
        <div
          className={classnames(styles.iconBox, isClickable && styles.iconBoxClickable)}
          onClick={handleIconClick}
          role={isClickable ? "button" : undefined}
          aria-label={
            collapsed
              ? "Expand sidebar"
              : updateAvailable
                ? "Update available — click to update"
                : undefined
          }
        >
          <span className={styles.iconInner}>{app.icon}</span>
          <span className={styles.expandIcon} aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M5.646 3.354a.5.5 0 01.708-.708l5 5a.5.5 0 010 .708l-5 5a.5.5 0 01-.708-.708L10.293 8 5.646 3.354z" />
            </svg>
          </span>
          {updateAvailable && <span className={styles.updateBadge} aria-label="Update available" />}
        </div>
        <div className={styles.logoText}>
          <span className={styles.appName}>{app.name}</span>
          <a
            href="https://hicya.org"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.byLine}
          >
            by hicya
          </a>
        </div>
        <button
          type="button"
          className={styles.chevronExpanded}
          onClick={onCollapseToggle}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
            <path d="M10.354 3.354a.5.5 0 00-.708-.708l-5 5a.5.5 0 000 .708l5 5a.5.5 0 00.708-.708L5.707 8l4.647-4.646z" />
          </svg>
        </button>
      </div>
    </div>
  );
}
